import type { ProjectNode } from '@/shared/types/projectData';

export const getMilestoneScheduleDate = (node: Partial<ProjectNode>): string | undefined =>
  node.date || node.endDate || node.dueDate || node.startDate || undefined;

export const getTaskScheduleStart = (node: Partial<ProjectNode>): string | undefined =>
  node.startDate || node.endDate || node.dueDate || undefined;

export const getTaskScheduleEnd = (node: Partial<ProjectNode>): string | undefined =>
  node.endDate || node.dueDate || node.startDate || undefined;
